module.exports = __webpack_public_path__ + "assets/img/1901591928118_.pic_hd.711eede2.jpg";